import { trigger, state, animate, transition, style } from '@angular/animations';

export const popUpActiveAnimation = [
    trigger('popUpActiveState', [
        state('inactive', style({
          opacity: '0',
          visibility: 'hidden',
          zIndex: '-10',
          top: '55%',
        })),
        state('active', style({
          opacity: '1',
          visibility: 'visible',
          zIndex: '900',
          top: '50%'
        })),
        transition('active <=> inactive', animate('400ms cubic-bezier(0.445, 0.05, 0.55, 0.95)'))
      ]),
      trigger('overlayActiveState', [
        state('inactive', style({
          opacity: '0',
          visibility: 'hidden',
          zIndex: '-10',
        })),
        state('active', style({
          opacity: '1',
          visibility: 'visible',
          zIndex: '300',
        })),
        transition('active <=> inactive', animate('400ms ease-in-out'))
      ])
]


// WEBPACK FOOTER //
// ./src/app/shared/animations/popup-center.animation.ts